import { render } from "./ItemLicenciasPendientes.vue?vue&type=template&id=6cdce95b&scoped=true"
import script from "./ItemLicenciasPendientes.vue?vue&type=script&lang=js"
export * from "./ItemLicenciasPendientes.vue?vue&type=script&lang=js"

import "./ItemLicenciasPendientes.vue?vue&type=style&index=0&id=6cdce95b&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdce95b"]])

export default __exports__